"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MfaSignature = void 0;

var _react = _interopRequireWildcard(require("react"));

var _MfaTexte = require("./MfaTexte");

var _MfaBouton = require("./MfaBouton");

var _MfaEnveloppe = require("./MfaEnveloppe");

var _semanticUiReact = require("semantic-ui-react");

var _utilitaires = require("../utils/utilitaires");

var _utilitaires2 = require("../utils/utilitaires.date");

var _propTypes = _interopRequireDefault(require("prop-types"));

require("../css/mfa-signature.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MfaSignature = /*#__PURE__*/function (_Component) {
  _inherits(MfaSignature, _Component);

  var _super = _createSuper(MfaSignature);

  function MfaSignature(props) {
    var _this;

    _classCallCheck(this, MfaSignature);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "messageDonneeNonValide", 'La valeur du champ {0} accepte juste caractères et ne doit pas dépasser les {1} caractères');

    _defineProperty(_assertThisInitialized(_this), "messageChampObligatoire", '{0} obligatoire');

    _this.surChangement = _this.surChangement.bind(_assertThisInitialized(_this));
    _this.surCliqueSignature = _this.surCliqueSignature.bind(_assertThisInitialized(_this));
    _this.state = {
      prenom: _this.props.prenom,
      nom: _this.props.nom,
      fonction: _this.props.fonction,
      dateSignature: _this.props.date,
      nomModifiable: false,
      prenomModifiable: false,
      fonctionModifiable: false
    };
    return _this;
  }

  _createClass(MfaSignature, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        nomExiste: (0, _utilitaires.nestPasNulOuVide)(this.state.nom),
        prenomExiste: (0, _utilitaires.nestPasNulOuVide)(this.state.prenom),
        fonctionExiste: (0, _utilitaires.nestPasNulOuVide)(this.state.fonction)
      });
    }
  }, {
    key: "desactiverDonnee",
    value: function desactiverDonnee(cle, valeurInitialeExiste) {
      return this.props.lectureSeule && (0, _utilitaires.nestPasNulOuVide)(this.state[cle]) && this.state[valeurInitialeExiste];
    }
  }, {
    key: "surChangement",
    value: function surChangement(cle, valeur, cleModifier) {
      var _this$setState;

      this.setState((_this$setState = {}, _defineProperty(_this$setState, cle, valeur), _defineProperty(_this$setState, cleModifier, true), _this$setState));
    }
  }, {
    key: "surCliqueSignature",
    value: function () {
      var _surCliqueSignature = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.valider("nom", "nomErreur", 'Nom', 55);

              case 2:
                _context.next = 4;
                return this.valider("prenom", "prenomErreur", 'Prénom', 60);

              case 4:
                _context.next = 6;
                return this.valider("fonction", "fonctionErreur", 'Fonction', 25);

              case 6:
                _context.next = 8;
                return this.verifierFormatDate();

              case 8:
                if ((0, _utilitaires.estDefini)(this.props.onClick) && !(0, _utilitaires.nestPasNulOuVide)(this.state.nomErreur) && !(0, _utilitaires.nestPasNulOuVide)(this.state.prenomErreur) && !(0, _utilitaires.nestPasNulOuVide)(this.state.fonctionErreur)) {
                  this.props.onClick(this.state.prenom, this.state.nom, this.state.fonction, this.state.dateSignature);
                }

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function surCliqueSignature() {
        return _surCliqueSignature.apply(this, arguments);
      }

      return surCliqueSignature;
    }()
  }, {
    key: "valider",
    value: function valider(cle, cleErreur, titre, length) {
      var _this2 = this;

      var valeur = this.state[cle];
      return new Promise(function (resoudre) {
        if (!(0, _utilitaires.nestPasNulOuVide)(valeur)) _this2.setState(_defineProperty({}, cleErreur, _this2.messageChampObligatoire.replace('{0}', titre)), resoudre);else if (!_this2.regleValidation(valeur, length)) _this2.setState(_defineProperty({}, cleErreur, _this2.messageDonneeNonValide.replace('{0}', titre).replace('{1}', length)), resoudre);else _this2.setState(_defineProperty({}, cleErreur, ''), resoudre);
      });
    }
  }, {
    key: "verifierFormatDate",
    value: function verifierFormatDate() {
      var _this3 = this;

      if (!(0, _utilitaires.nestPasNulOuVide)(this.props.date)) {
        return new Promise(function (resoudre) {
          _this3.setState({
            dateSignature: new Date().toString()
          }, resoudre);
        });
      }
    }
  }, {
    key: "regleValidation",
    value: function regleValidation(valeur, length) {
      var regex = new RegExp("^[a-zA-Z]{1," + length + "}$");
      return regex.test(valeur);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          permission = _this$props.permission,
          estSigne = _this$props.estSigne;

      if (!permission) {
        return null;
      }

      if (estSigne) {
        var _this$props2 = this.props,
            nom = _this$props2.nom,
            prenom = _this$props2.prenom,
            fonction = _this$props2.fonction,
            date = _this$props2.date;
        var personne = prenom + ' ' + nom;
        var dateAffichee = new Date(date);
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
          className: "mfa-signature"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "mfa-signature-contenant-lg"
        }, /*#__PURE__*/_react.default.createElement(_MfaEnveloppe.MfaEnveloppe, {
          etiquette: fonction
        }, personne)), /*#__PURE__*/_react.default.createElement("div", {
          className: "mfa-signature-contenant-lg"
        }, /*#__PURE__*/_react.default.createElement(_MfaEnveloppe.MfaEnveloppe, {
          style: {
            paddingLeft: '5px'
          },
          etiquette: "Date et heure"
        }, (0, _utilitaires2.formaterDateHeureCourante)(dateAffichee))), /*#__PURE__*/_react.default.createElement("div", {
          className: "mfa-signature-contenant-sm"
        }, /*#__PURE__*/_react.default.createElement(_MfaEnveloppe.MfaEnveloppe, null, /*#__PURE__*/_react.default.createElement("div", {
          style: {
            paddingLeft: '5px'
          }
        }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
          color: "green",
          size: "large",
          name: "check"
        }), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
          color: "blue",
          size: "large",
          name: "user"
        }))))));
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "mfa-signature"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "mfa-signature-contenant"
      }, /*#__PURE__*/_react.default.createElement(_MfaTexte.MfaTexte, {
        estObligatoire: true,
        etiquette: "Pr\xE9nom",
        taille: "md",
        valeur: this.state.prenom,
        surChangement: function surChangement(value) {
          return _this4.surChangement("prenom", value, "prenomModifiable");
        },
        messageErreur: this.state.prenomErreur,
        lectureSeule: this.desactiverDonnee("prenom", "prenomExiste")
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "mfa-signature-contenant"
      }, /*#__PURE__*/_react.default.createElement(_MfaTexte.MfaTexte, {
        estObligatoire: true,
        etiquette: "Nom",
        taille: "md",
        valeur: this.state.nom,
        surChangement: function surChangement(value) {
          return _this4.surChangement("nom", value, "nomModifiable");
        },
        messageErreur: this.state.nomErreur,
        lectureSeule: this.desactiverDonnee("nom", "nomExiste")
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "mfa-signature-contenant"
      }, /*#__PURE__*/_react.default.createElement(_MfaTexte.MfaTexte, {
        estObligatoire: true,
        etiquette: "Fonction",
        taille: "md",
        valeur: this.state.fonction,
        surChangement: function surChangement(value) {
          return _this4.surChangement("fonction", value, "fonctionModifiable");
        },
        messageErreur: this.state.fonctionErreur,
        lectureSeule: this.desactiverDonnee("fonction", "fonctionExiste")
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "mfa-signature-contenant"
      }, /*#__PURE__*/_react.default.createElement(_MfaBouton.MfaBouton, {
        estPrincipal: true,
        onClick: this.surCliqueSignature
      }, "Signer")));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (!prevState.nomModifiable && nextProps.nom !== prevState.nom) {
        return {
          nom: nextProps.nom
        };
      }

      if (!prevState.prenomModifiable && nextProps.prenom !== prevState.prenom) {
        return {
          prenom: nextProps.prenom
        };
      }

      if (!prevState.fonctionModifiable && nextProps.fonction !== prevState.fonction) {
        return {
          fonction: nextProps.fonction
        };
      }

      return null;
    }
  }]);

  return MfaSignature;
}(_react.Component);

exports.MfaSignature = MfaSignature;

_defineProperty(MfaSignature, "defaultProps", {
  lectureSeule: true
});

_defineProperty(MfaSignature, "propTypes", {
  lectureSeule: _propTypes.default.bool
});